<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { analysesApi } from '@/services/api/analyses';

const route = useRoute();
const router = useRouter();
const form = reactive({ name: '', description: '' });
const submitting = ref(false);

function projectIdParam(): string {
  const raw = route.params.id;
  return Array.isArray(raw) ? (raw[0] ?? '') : raw ?? '';
}

async function submit(): Promise<void> {
  if (form.name.length === 0 || submitting.value) return;
  submitting.value = true;
  try {
    const created = await analysesApi.create(projectIdParam(), form);
    await router.replace({
      name: 'projectAnalysisEdit',
      params: { id: projectIdParam(), analysis_id: String(created.id) },
    });
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <section class="resource">
    <h1>New Analysis</h1>
    <form class="resource__form" @submit.prevent="submit">
      <label><span>Name</span><input v-model="form.name" type="text" required /></label>
      <label><span>Description</span><textarea v-model="form.description" rows="4" /></label>
      <button type="submit" :disabled="submitting">Create Analysis</button>
    </form>
  </section>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
<style scoped>
.resource__form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 32rem;
}
.resource__form input,
.resource__form textarea {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
}
.resource__form button {
  align-self: flex-start;
  padding: 0.5rem 1rem;
  background: #2563eb;
  color: #fff;
  border: 0;
  border-radius: 0.375rem;
  cursor: pointer;
}
</style>
